<template>
<div class="schemeHomepage">
	<div class="schemeHomepage-banner" :style="{height:bannerHeight}">
		<div class="schemeHomepage-banner-content">
			<div class="schemeHomepage-banner-title">卡奥斯风险管理（保险）解决方案</div>
			<p class="schemeHomepage-banner-desc">
				全掌柜科技，系海尔集团旗下子公司，<br>
				以其全资子公司“青岛海尔保险代理有限公司”为依托，<br>
				在满足海尔集团内部企业保险需求的基础上，逐步向上下游生态圈业务拓展，<br>
				服务海尔集团内部客户数百家，上下游客户过万家，搭建起针对企业客户的风险解决方案科技平台，<br>
				针对于各行业定制人员、财产、设备、信用等综合保险解决方案，<br>
				为企业降低保费成本，扩大承保范围，提升理赔时效。
			</p>
		</div>
	</div>
	<div class="schemeHomepage-introduction">
		<img src="/static/images/scheme/homepage_bg1.png" class="schemeHomepage-introduction-bg1">
		<img src="/static/images/scheme/homepage_bg2.png" class="schemeHomepage-introduction-bg2">
		<img src="/static/images/scheme/homepage_bg3.png" class="schemeHomepage-introduction-bg3">
		<div class="schemeHomepage-centerContainer">
			<img src="/static/images/scheme/homepage_bg0.png" width="1200">
			<p class="schemeHomepage-introduction-title title1">企业痛点</p>
			<p class="schemeHomepage-introduction-title title2">我们的优势</p>
			<div class="schemeHomepage-introduction-desc desc1">
				<p class="schemeHomepage-introduction-desc-item">企业在经营过程中，对保险不了解，不知道企业应该匹配什么样的保险能够抵御经营过程中的重大损失风险；</p>
				<p class="schemeHomepage-introduction-desc-item">企业想为自己的员工、存货、固定资产、设备等购买保险，但保险公司往往因各种条件达不到要求原因拒绝承保；</p>
				<p class="schemeHomepage-introduction-desc-item">保险公司能够承保的情况下，因企业自身年度保费规模小，保险公司出具的方案保费往往费率高；</p>
				<p class="schemeHomepage-introduction-desc-item">保险各种条款及种类复杂尤其是财产保险和员工保险，企业往往投保后遇到财产损失，却被告知不在理赔范围内，保险公司给予拒赔；</p>
				<p class="schemeHomepage-introduction-desc-item">出险后在面对保险公司走理赔流程时属于弱势群体，话语权小，理赔流程和手续，最终的理赔金额往往达不到自己的预期。</p>
			</div>
			<div class="schemeHomepage-introduction-desc desc2">
				<p class="schemeHomepage-introduction-desc-item">依托海尔集团大客户保险资源，将集团自用方案开放给海尔生态资源方，保障平台方案为行业最优方案；</p>
				<p class="schemeHomepage-introduction-desc-item">20余年企业端风险管理及理赔服务经验，专业的理赔服务团队，在企业遇到损失时，协助企业进行理赔服务，保障赔付金额最大，理赔时效最优，为平台企业端客户解决理赔后顾之忧；</p> 
				<p class="schemeHomepage-introduction-desc-item">无需现场核保，全国（港澳台除外）全流程线上出保单，操作简单。</p>
			</div>

		</div>
	</div>
	<div class="schemeHomepage-centerContainer">
		<div class="schemeHomepage-centerContainer-title">方案全景图</div>
		<div class="schemeHomepage-scheme">
			<div class="schemeHomepage-scheme-item" v-for="(item, index) in schemeList" :key="index" @click="toScheme(item.url)">
				<img :src="`/static/images/scheme/homepage_scheme_${index+1}.jpg`" />
				<div class="schemeHomepage-scheme-item-content">
					<div class="schemeHomepage-scheme-item-name">{{(index+1)<10?`0${index+1}`:index+1}}</div>
					<div class="schemeHomepage-scheme-item-desc">{{item.name}}</div>
				</div>
			</div>
		</div>
	</div>
	<div class="schemeHomepage-centerContainer">
		<div class="schemeHomepage-centerContainer-title">通用产品</div>
		<div class="schemeHomepage-product">
			<div class="schemeHomepage-product-item" 
				v-for="(item, index) in list" 
				:key="index" 
				@click="toDetail(item.url)"
				:class="{pointer:item.url}"
			>
				<img :src="item.img" width="100%"/>
				<div class="schemeHomepage-product-item-content">
					<p class="schemeHomepage-product-item-name">{{item.name}}</p>
					<p class="schemeHomepage-product-item-desc" :class="[item.class]">{{item.desc}}</p>
				</div>
			</div>
		</div>
	</div>
	<div class="schemeHomepage-centerContainer">
		<img src="/static/images/scheme/contact.jpg" width="100%" />
		<div class="schemeHomepage-contact">
			<div class="schemeHomepage-contact-title">企业定制保险咨询</div>
			<div class="schemeHomepage-contact-subtitle">专业团队 · 方案定制 · 优化成本 · 理赔服务</div>
			<div class="schemeHomepage-contact-phone400">400-100-0316 <span>转</span> 3</div>
			<div class="schemeHomepage-contact-phone">0532-88931681（周一到周六9:00-17:00）</div>
		</div>
	</div>
	<br>
</div>
</template>
<script>
import {products} from './common/dictionary'
export default {
	data(){
		let list=[0,1,2,3,6,4]
		list.forEach((item,index)=>{
			list[index]=products[item]
		})
		return {
			bannerHeight:'',
			schemeList:[
				{
					name:'家电行业风险解决方案',
					url:'/jiadian'
				},
				{
					name:'模具行业风险解决方案',
					url:'/muju'
				},
				{
					name:'服装行业风险解决方案',
					url:'/fuzhuang'
				},
				{
					name:'化工行业风险解决方案',
					url:'/huagong'
				},
				{
					name:'机械制造行业风险解决方案',
					url:'/jixie'
				},
				{
					name:'建材行业风险解决方案',
					url:'/jiancai'
				},
				{
					name:'电子行业风险解决方案',
					url:'/dianzi'
				},
				{
					name:'建筑行业风险解决方案',
					url:'/jianzhu'
				},
				{
					name:'食品行业风险解决方案',
					url:'/shipin'
				},
				{
					name:'房车改造行业风险解决方案',
					url:'/fangche'
				},
				{
					name:'农业行业风险解决方案',
					url:'/nongye'
				},
				{
					name:'大健康风险解决方案',
					url:'/health'
				}
			],
			list:list
		}
	},
	mounted(){
		const that=this;
		this.bannerHeight = `${document.documentElement.clientHeight-90}px`;
		window.onresize = function() {
			that.bannerHeight = `${document.documentElement.clientHeight-90}px`;
		};
	},
	methods:{
		// 产品详情
		toDetail(url){
			if(url){
				location.href=url
			}
		},
		// 方案
		toScheme(url) {
			this.$router.push(url)
		}
	}
}
</script>
<style scoped lang="less">
.schemeHomepage{
	&-centerContainer{
		width: 1200px;
		margin: 40px auto 0;
		display: block;
		position: relative;
		&-title{
			text-align: center;
			font-size: 40px;
			margin-bottom: 54px;
			&::before,&::after{
				content: '';
				width: 37px;
				height: 24px;
				display: inline-block;
				background: url(/static/images/scheme/icon_title.png);
				margin: 0 16px;
			}
		}
	}
	&-banner{
		background: url(/static/images/scheme/homepage_banner.jpg) no-repeat;
		background-size: cover;
		text-align: center;
		color: #fff;
		min-height: 400px;
		&-content{
			position: relative;
			top: 12%;
		}
		&-title{
			font-size: 3.75rem;
			margin-bottom: 70px;
			line-height: 1;
		}
		&-desc{
			font-size: 1.25rem;
			line-height: 1.6;
		}
	}
	&-introduction{
		padding: 140px 0 130px;
		position: relative;
		&-bg1{
			position: absolute;
			left: 0;
			top: 0;
		}
		&-bg2{
			position: absolute;
			left: 0;
			top: 500px;
		}
		&-bg3{
			position: absolute;
			right: 0;
			bottom: 0;
		}
		&-title{
			position: absolute;
			font-size: 40px;
			&.title1{
				top: -55px;
				left: 460px;
			}
			&.title2{
				top: 455px;
    			left: 50px;
			}
		}
		&-desc{
			position: absolute;
			width: 666px;
			font-size: 18px;
			&-item{
				margin-bottom: 15px;
				&::before{
					content: '';
					display: inline-block;
					width: 20px;
					height: 20px;
					margin-right: 10px;
					position: relative;
					top: 2px;
				}
			}
			&.desc1{
				top: 46px;
    			left: 480px;
				.schemeHomepage-introduction-desc-item::before{
					background: url('/static/images/scheme/homepage_icon_1.png');
				}
			}
			&.desc2{
				top: 575px;
				left: 50px;
				.schemeHomepage-introduction-desc-item::before{
					background: url('/static/images/scheme/homepage_icon_2.png');
				}
			}

		}
	}
	&-scheme{
		width: 1218px;
		margin-left: -9px;
		&::after{
			content:'';
			display: block;
			clear: both;
		}
		&-item{
			width: 286px;
			height: 193px;
			margin: 0 9px 30px;
			box-shadow: 0 0 10px #ddd;
			float: left;
			border: 3px solid #ffffff;
			border-radius: 5px;
			cursor: pointer;
			position: relative;
			color: #fff;
			&-content{
				position: absolute;
				top: 0;
				width: 100%;
				left: 0;
				height: 100%;
				padding-top: 50px;
				text-align: center;
				&:hover{
					background: rgba(0,0,0,0.5);
				}
			}
			&-name{
				font-size: 40px;
				line-height: 1;
				margin-bottom: 16px;
			}
			&-desc{
				font-size: 20px;
			}
		}
	}
	&-product{
		width: 1236px;
		margin-left: -18px;
		&::after{
			content:'';
			display: block;
			clear: both;
		}
		&-item{
			width: 375px;
			margin: 0 18px 30px;
			box-shadow: 0 0 10px #ddd;
			float: left;
			&.pointer{
				cursor: pointer;
			}
			&-content{
				padding: 24px;
				height: 200px;
			}
			&-name{
				font-size: 24px;
				line-height: 1;
				margin-bottom: 16px;
			}
			&-desc{
				font-size: 18px;
				color: #666;
				&.fz16{
					font-size: 16px;
					line-height: 1.3;
				}
			}
		}
	}
	&-contact{
		left: 0;
		top: 72px;
		color: #fff;
		line-height: 1;
		position: absolute;
		text-align: center;
		width: 100%;
		&-title{
			font-size: 48px;
		}
		&-subtitle{
			font-size: 20px;
			margin-top: 20px;
		}
		&-phone{
			font-size: 18px;
			margin-top: 20px;
		}
		&-phone400{
			font-size: 36px;
			margin-top: 40px;
			color: #ffc742;
			span{
				font-size: 32px;
				vertical-align: top;
			}
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/pages/scheme/components/Home.vue